__turbopack_context__.v({
  "categories": "searchCategories-module-scss-module__4e39uG__categories",
  "category": "searchCategories-module-scss-module__4e39uG__category",
  "categoryCount": "searchCategories-module-scss-module__4e39uG__categoryCount",
  "categoryName": "searchCategories-module-scss-module__4e39uG__categoryName",
});
